import React from 'react';

const ServicesMinimal = () => {
  const services = [
    {
      name: 'Paid Social Campaigns',
      description: 'Meta and TikTok ad strategy with AI-powered audience segmentation, automated creative testing, and predictive budget allocation that consistently beats platform averages',
      tag: 'Meta & TikTok'
    },
    {
      name: 'Instagram Growth Strategy',
      description: 'Organic reach acceleration through AI-driven content scheduling, engagement pattern analysis, and community building tactics that turn followers into customers',
      tag: 'Organic + Paid'
    },
    {
      name: 'SEO & Content Marketing',
      description: 'AI-assisted keyword research, search-optimised blog content, and on-page strategy that drives qualified organic traffic from Google search in Berlin and beyond',
      tag: 'Long-term ROI'
    },
    {
      name: 'Email Marketing Automation',
      description: 'List building funnels, behavioural flows, and AI-generated campaign variations that turn subscribers into repeat buyers with measurable conversion lifts',
      tag: null
    },
    {
      name: 'Performance Marketing',
      description: 'Full-funnel campaign management across all channels with AI-powered attribution modelling, conversion tracking, and data-driven optimisation at every touchpoint',
      tag: 'Full Funnel'
    },
    {
      name: 'AI-Driven Growth Consulting',
      description: 'Strategic integration of AI tools across your marketing stack — from audience insights to creative production — accelerating results without scaling headcount',
      tag: 'Cutting Edge'
    }
  ];

  return (
    <section id="services" className="bg-black border-y border-tertiary">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        {/* Section Label */}
        <div className="mb-16">
          <span className="text-sm text-tertiary font-sans uppercase tracking-wider">Services</span>
        </div>

        {/* Services List */}
        <div className="space-y-16">
          {services.map((service) => (
            <div key={service.name} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-start">
              {/* Service Name */}
              <div className="lg:col-span-4">
                <div className="flex items-center gap-3">
                  <h3 className="font-serif text-2xl lg:text-3xl text-gold">
                    {service.name}
                  </h3>
                  {service.tag && (
                    <span className="px-3 py-1 text-xs font-sans text-secondary border border-tertiary rounded-full">
                      {service.tag}
                    </span>
                  )}
                </div>
              </div>

              {/* Service Description */}
              <div className="lg:col-span-8">
                <p className="text-lg text-secondary font-sans leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesMinimal;
